export const carePlanMenuDef = [
    {
        "name": "menu.care_plan_format",
        "resource": "care_plan_format",
        "icon": "fa fa-user-md",
        "url": "care_plan_format",
        "auto_crud": true,
        "showMenu": false
    },
    {
        "name": "menu.care_plan_inprogress_patient_list",
        "resource": "care_plan_inprogress_patient_list",
        "icon": "fa fa-user-md",
        "url": "care_plan_inprogress_patient_list",
        "auto_crud": true,
        "showMenu": false
    },
    {
        "name": "menu.care_plan_patient_list",
        "resource": "care_plan_patient_list",
        "icon": "fa fa-user-md",
        "url": "care_plan_patient_list",
        "auto_crud": true,
        "showMenu": false
    },
    {
        "name": "menu.care_plan_force_closed",
        "resource": "care_plan_force_closed",
        "icon": "fa fa-user-md",
        "url": "care_plan_force_closed",
        "auto_crud": true,
        "showMenu": false
    },
    {
        "name": "menu.care_plan_cancelled",
        "resource": "care_plan_cancelled",
        "icon": "fa fa-user-md",
        "url": "care_plan_cancelled",
        "auto_crud": true,
        "showMenu": false
    },
    {
        "name": "menu.care_plan_expired",
        "resource": "care_plan_expired",
        "icon": "fa fa-user-md",
        "url": "care_plan_expired",
        "auto_crud": true,
        "showMenu": false
    },
    {
        "name": "menu.care_plan_completed",
        "resource": "care_plan_completed",
        "icon": "fa fa-user-md",
        "url": "care_plan_completed",
        "auto_crud": true,
        "showMenu": false
    }
]